import React from 'react';
import {
    AccountCircleOutlined, 
    Smartphone, 
    MailOutline, 
    PictureAsPdfOutlined, 
    CalendarToday, 
    DeleteOutline,
    MonetizationOnOutlined,
    Edit,
} from '@material-ui/icons';

export const helps = [
    {
        "titolo": "dashboard",
        "titoli_sezioni": [
            "Dashboard"
        ],
        "sezioni": [
            "Dalla <b>Dashboard</b> è possibile visualizzare il menù con tutte le <b>sezioni di Hdemia</b> sulla sinistra. Oppure, facendo click sul questa <b>icona<b> ##0##, in alto a destra, è possibile accedere alle funzioni di: <br/><br/>• Profilo;<br/>• Pagamenti;<br/>• Assistenza;<br/>• Esci.<br/>"
        ], 
        "immagini": [
            [
                <AccountCircleOutlined />
            ]
        ]
    }, 
    {
        "titolo": "usersettings",                            
        "titoli_sezioni": [
            "Impostazioni del Profilo",         
        ], 
        "sezioni": [
            "In questa Sezione puoi facilmente <b>modificare la tua Password</b>. Ti basterà inserire la Password corrente e la nuova. Confermando quest’ultima prima di aggiornarla tramite apposito bottone \"Aggiorna Password\""
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "account", 
        "titoli_sezioni": [
            "Account e Pagamenti",
       ], 
        "sezioni": [
            "In questa Sezione puoi <b>visualizzare il tuo Piano attuale e cambiare offerta</b>. Trovi tutte le informazioni su <b>cosa è incluso nei vari piani</b> Free, Premium e Custom",
       ], 
       "immagini": [[]]
   },
   {
        "titolo": "sendFeedback", 
        "titoli_sezioni": [
            "Assistenza",
        ], 
        "sezioni": [
            "Nella Sezione Assistenza è possibile richiedere con facilità un <b>nuovo ticket</b> nel caso si dovesse riscontrare una problematica nell’utilizzo di Hdemia o si necessiti di supporto. Puoi <b>rintracciare un ticket</b> tramite la funzione \"Cerca\" o direttamente dall’elenco.",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "corsi", 
        "titoli_sezioni": [
            "Inserire un nuovo corso",
            "Visualizzare le informazioni di un corso", 
	        "Azioni rapide tramite le icone della tabella"
        ], 
        "sezioni": [
            "Per <b>creare un nuovo corso</b> basta semplicemente cliccare sul bottone in alto a destra <b>\"Nuovo\"</b>. Sarà quindi possibile inserire il nome del nuovo corso, la sua durata e l’anno accademico di riferimento",
            "Per ottenere e modificare le informazioni di un corso è necessario cliccare sulla riga di riferimento.", 
	        "Le azioni rapide ti permetteranno di: <br/>•Inviare una notifica ##0## sull’app di coloro che partecipano al corso;<br/>• Inviare una mail ##1## ai partecipanti del corso;<br/>•Generare un PDF ##2## selezionando un intervallo di date per il calcolo;<br/>• Accedere alla funzione calendario per inserire nuove lezioni (anche online) nella giornata e all’orario che si desidera ##3##;<br/>• Eliminare il corso ##4## dalla lista."
        ], 
        "immagini": [
            [],
            [], 
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <CalendarToday />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "editCorso", 
        "titoli_sezioni": [
            "Dettaglio Corso",
        ], 
        "sezioni": [
            "All’interno della Sezione <b>“Dettagli Corso”</b> è possibile inserire in modo semplice <b>tutte le informazioni del corso</b> di riferimento. Inserisci il nome nell’apposito box, la durata del corso e l’anno accademico. L’opzione <b>“Divisione fatturato lezione”</b> permette di dividere le ore di lezione sui professori inseriti - esempio: lezione di un’ora con due professori, 30 min. fatturati a testa. È possibile consultare la <b>lista degli studenti</b> appartenenti al corso nella Sezione subito sotto <b>“Lista studenti”</b> . Qui, puoi visualizzare velocemente i dati degli studenti, la percentuale delle assenze e la media esami. Tramite questa lista puoi indicare come “Ritirato” ##0## lo studente selezionato , oppure generare un PDF ##1## con il riepilogo degli esami sostenuti dallo stesso per quel corso. Puoi stampare le medie del corso di riferimento cliccando l’apposito bottone a destra “Stampa Medie del Corso”<br/><br/>##2##<br/><br/>È possibile visualizzare il <b>calendario esami</b> per il corso selezionato e aggiungerne di nuovi tramite il bottone “Aggiungi”<br/><br/>##3##<br/><br/>Nel dettaglio, la tabella riporta le date degli esami, la materia di riferimento, l’insegnante, delle note e la tipologia di esame (orale o scritto). Per ogni esame puoi generare un PDF ##4## che <b>riporta i nomi degli studenti con le relative valutazioni</b>. Oppure, puoi eliminare quell’esame dalla lista ##5##."
        ], 
        "immagini": [
            [               
                <img src={ require('../images/remove-user.png') } style={{ width: 15, height: 15, objectFit: 'contain', textAlign: 'center' }} />,
                <PictureAsPdfOutlined />, 
                <img src={ require('../images/stampa_medie.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/aggiungi.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
                <PictureAsPdfOutlined />,
                <DeleteOutline />
            ]
        ]
    },
    {
        "titolo": "studenti", 
        "titoli_sezioni": [
            "Aggiungere un nuovo studente",
            "Visualizzare le informazioni di uno studente", 
	        "Azioni rapide tramite le icone della tabella"
        ], 
        "sezioni": [
            "Per <b>aggiungere un nuovo studente</b> è necessario cliccare sull’apposito bottone in altro a destra <b>\"Aggiungi\"</b>. Inserisci quindi tutti i dati dello studente e assegnalo al corso di riferimento.",
            "Clicca sulla riga di uno studente per poterne <b>visualizzare le informazioni</b>. Una volta cliccato, potrai modificare o consultare i dati.", 
	        "Per ogni Studente è possibile utilizzare le icone presenti nella tabella per effettuare delle azioni rapide:<br/>• Invia una notifica direttamente all’App dello studente ##0##;<br/>• Invia una email allo studente ##1##;<br/>• Per ogni studente, puoi generare un PDF ##2## con i dettagli degli esami sostenuti e relativa media complessiva;<br/>• Elimina uno studente dall’elenco ##3##."
        ], 
        "immagini": [
            [],
            [],
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "editStudente", 
        "titoli_sezioni": [
            "Modifica Studente",
        ], 
        "sezioni": [
            "Nella Sezione <b>\"Modifica Studente\"</b> è possibile modificare in modo semplice e veloce tutte le informazioni del singolo studente. Inoltre, cliccando sul bottone <b>\"Invia credenziali utente\"</b> puoi inviare le credenziali allo studente selezionato così che possa <b>accedere ad Hdemia</b> da App Mobile o dal Web",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "insegnanti", 
        "titoli_sezioni": [
            "Aggiungere un nuovo insegnante",
            "Visualizzare le informazioni di un insegnante", 
	        "Azioni rapide tramite le icone della tabella",
            "Generazione PDF e Excel per report fatturato"
        ], 
        "sezioni": [
            "Per <b>aggiungere un insegnante al gestionale</b> è necessario cliccare sull’apposito bottone in alto a destra <b>\"Aggiungi\"</b>, sarà poi possibile inserire tutte le informazioni.",
            "Clicca sulla riga di un insegnante per poterne <b>visualizzare le informazioni</b>. Una volta cliccato, potrai modificare o consultare i dati.", 
	        "Per ogni Insegnante è possibile utilizzare le icone presenti nella tabella per effettuare delle azioni rapide:<br/>• Invia una notifica direttamente all’App dell’insegnante ##0##;<br/>• Invia una email all’insegnante ##1##;<br/>• Genera un PDF ##2## selezionando un intervallo di date per il calcolo del documento;<br/>• Consulta i dati di fatturazione ##3##, così da visualizzare le ore da fatturare dell’insegnante selezionato;<br/>• Elimina un insegnante dall’elenco ##4##.",
            "Tramite in due appositi bottoni in alto <b>\"Genera PDF\"</b> e <b>\"Genera Excel\"</b> è possibile scaricare dei <b>report del fatturato</b> inserendo l’intervallo di periodo desiderato - esempio 09/2021.<br/><br/>##0##" 
        ], 
        "immagini": [
            [],
            [],
            [<Smartphone />, <MailOutline />, <PictureAsPdfOutlined />, <MonetizationOnOutlined />, <DeleteOutline />],
            [
                <img src={ require('../images/pdf_excel.png') } style={{ width: '100%', height: 50, objectFit: 'contain', textAlign: 'center' }} />,
            ]
        ]
   },
   {
        "titolo": "editInsegnante", 
        "titoli_sezioni": [
            "Modifica Insegnante",
        ], 
            "sezioni": [
                "Nella Sezione <b>\"Modifica Insegnante\"</b> è possibile modificare in modo semplice e veloce tutte le informazioni del singolo insegnante. Inoltre, cliccando sul bottone <b>\"Invia credenziali utente\"</b> puoi inviare le credenziali all’insegnante selezionato così che possa <b>accedere ad Hdemia</b> da App Mobile o dal Web",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "aule", 
        "titoli_sezioni": [
            "Aggiungere una nuova Aula",
            "Azioni rapide tramite le icone della tabella", 
        ], 
        "sezioni": [
            "Per <b>aggiungere una nuova Aula</b> è necessario cliccare sull’apposito bottone in alto a destra <b>\"Aggiungi\"</b>. Sarà poi possibile inserire il nome dell’aula e la relativa capienza",
            "Per ogni Aula è possibile compiere delle azioni rapide tramite le icone riportate nella tabella:<br/>• Genera un PDF ##0## selezionando un intervallo di date per il calcolo del documento;<br/>• Accedi alla funzione calendario ##1##. Seleziona un intervallo di date per il calcolo desiderato;<br/>• Elimina un’aula dall’elenco ##2##.", 
        ], 
        "immagini": [
            [],
            [<PictureAsPdfOutlined />, <CalendarToday />, <DeleteOutline />]
        ]
   },
   {
        "titolo": "notifiche", 
        "titoli_sezioni": [
            "Notifiche",
        ], 
        "sezioni": [
            "Nella Sezione <b>\"Notifiche\"</b> trovi tutte le <b>notifiche che sono state inviate</b> dal Sistema alle App mobili",
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "scuola", 
        "titoli_sezioni": [
            "Festività Scolastiche",
    
        ], 
        "sezioni": [
            "Utilizza l’apposito calendario per <b>impostare i giorni di chiusura</b> della tua scuola. Clicca su una data aggiungere una festività scolastica, clicca nuovamente per rimuoverla.",
        ], 
        "immagini": []
   },
   {
        "titolo": "cestinoCorsi", 
        "titoli_sezioni": [
            "Cestino Corsi",
        "Eliminare definitivamente un corso", 
        ], 
        "sezioni": [
            "Nella Sezione <b>\"Cestino Corsi\"</b> ritrovi tutti i corsi eliminato. Cliccando sul singolo corso è possibile <b>visualizzare le sue informazioni</b>.",
            "Cliccando sull’icona ##0## sulla riga del singolo corso eliminato, è possibile <b>cancellare definitivamente il corso</b>. <b>I corsi così eliminati non potranno più essere recuperati</b>.",
        ], 
        "immagini": [
            [], 
            [<DeleteOutline />]
        ]
    },
    {
        "titolo": "adminSettings", 
        "titoli_sezioni": [
            "Impostazioni",
            "Impostazioni Invio Email", 
	        "Personalizzazione Web & App Mobile"
        ], 
        "sezioni": [
            "<b>Caricando e impostando il logo della tua Scuola potrai personalizzare il gestionale e i documenti PDF generati, in modo automatico</b>. Per l’App Mobile è possibile scegliere <b>un’immagine o un colore di sfondo</b> così da uniformare l’applicazione alla tua Scuola - è preferibile che l’immagine scelta abbia un’altezza maggiore della larghezza. Per impostare il colore desiderato è sufficiente cliccare nell’apposita sezione <b>Sfondo Menù App mobile</b>:<br/><br/>##0##<br/><br/>In alternativa, se si vuole <b>aggiungere un’immagine</b> basterà cliccare sul pulsante seleziona e scegliere tra le opzioni proposte dal gestionale oppure caricare un file dal proprio computer cliccando qui:<br/><br/>##1##<br/><br>È possibile <b>caricare il logo della propria Scuola</b> cliccando sull’apposito pulsante sotto \"Logo\":<br/><br/>##2##",
            "Compilando i campi sotto <b>Impostazioni invio email</b> potrai inviare email ad alunni e insegnanti. Inserisci l’<b>indirizzo email da cui spedire i messaggi</b> e il <b>nome che apparirà ai destinatari</b>. Ricordati di verificare, in seguito, l’indirizzo di posta elettronica inserito.",
            "Tramite la <b>Personalizzazione Web & App Mobile</b> puoi modificare i colori e il menù dell’app mobile di Hdemia così da uniformarli all’immagine della tua Accademia.<br/><b><i>NB: Gli utenti dovranno chiudere e riaprire l’app per poter visualizzare le modifiche</i></b>.<br/>Scegli il colore primario e il colore secondario che desideri, cliccando nelle apposite sezioni:<br/><br/>##0## ##1##<br/><br/>##2##<br/><br/>Inoltre, tramite <b>\"Sezioni del menù dell’App mobile\"</b> puoi decidere quali sezioni rendere disponibili agli utenti della tua applicazione mobile.<br/><br/>##3##<br/><br/>È possibile anche <b>personalizzare il colore dei testi del menù mobile</b> tramite l'apposito bottone:<br/><br/>##4##"
        ], 
        "immagini": [
            [
                <img src={ require('../images/help_1.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/help_2.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/help_3.png') } style={{ width: '100%', height: 100, objectFit: 'contain', textAlign: 'center' }} />
            ], 
            [], 
            [
                <img src={ require('../images/primario.png') } style={{ width: '50%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/secondario.png') } style={{ width: '50%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/colori.png') } style={{ width: '100%', height: 150, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/sezioni.png') } style={{ width: '100%', height: 150, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/colore_testo.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
    },
    {
        "titolo": "users", 
        "titoli_sezioni": [
            "Aggiungi un nuovo utente",
            "Gestione Utenti"
        ], 
        "sezioni": [
            "Per <b>aggiungere un nuovo utente</b> bisogna semplicemente cliccare sul tasto in alto a destra ”<b>Aggiungi</b>”. Crea un nuovo utente inserendo le sue informazioni e i suoi privilegi, ovvero determinare se sarà un utente <b>amministratore<b/> o <b>fatturazione</b>.<br/><br/>• <b>Account Amministratore</b>: può modificare i corsi, gli studenti e ogni altra impostazione della scuola sul gestionale. Inoltre, ha accesso a tutte le informazioni riguardanti la fatturazione.<br/><br/>• <b>Account Fatturazione</b>: questo account può accedere e modificare solo le informazioni relative alle rate e alle fatture. Non può né accedere né visualizzare le informazioni riguardanti i corsi, gli studenti, ecc.<br/><br/>Per ogni account che si desidera aggiungere è necessario inserire mail e password.",
            "Puoi visualizzare gli utenti del gestionale direttamente dalla tabella. Per ogni utente è possibile vedere il proprio <b>username</b> e la <b>tipologia</b> (Amministratore o Fatturazione). Inoltre, è possibile eliminare un utente cliccando sull’icona ##0## della riga di riferimento."
        ], 
        "immagini": [
            [], 
            [<DeleteOutline />]
        ]
   },
   {
        "titolo": "billing/corsi", 
        "titoli_sezioni": [
            "Fatturazione Corsi"
        ], 
        "sezioni": [
            "Per visualizzare i <b>dettagli di fatturazione del singolo corso</b>, basta cliccare sulla riga di riferimento e si aprirà un <b>pannello del piano rateale</b> del corso selezionato"
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/editCorso", 
        "titoli_sezioni": [
            "Piano Rateale del Corso",
            "Piano Rateale studente"
        ], 
        "sezioni": [
            "Per ogni singolo corso è possibile definire il relativo piano rateale. Per procedere, ti basterà inserire il costo per il singolo studente nell’apposita sezione:<br/><br/>##0##<br/><br/>• Per <b>aggiungere una rata</b> è necessario cliccare sull’apposito bottone .<br/> Imposta la data per il pagamento e inserisci il relativo importo, questo procedimento va ripetuto per ogni rata che si intende programmare - esempio: se ho intenzione di dividere il costo del corso i 3 rate, dovrò cliccare sul bottone “Aggiungi rata” 3 volte. Ogni volta impostando la data di riferimento e il relativo importo. Avrò dunque, in questo caso, un elenco con 3 rate.<br/>Prima di terminare, ricordati di <b>salvare il piano rateale</b> cliccando sull’apposito bottone<br/><br/>##1##",
            "In fondo alla pagina del Piano Rateale del corso compare una tabella con i <b>nomi degli studenti, relativo piano rateale e percentuale di pagamento</b>. Per <b>visualizzare i dettagli</b> è necessario cliccare sulla riga dello studente selezionato."
       ], 
       "immagini": [
           [
                <img src={ require('../images/agg_rata.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
                <img src={ require('../images/salva_rate.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />,
           ], 
           [] 
       ]
   },
   {
        "titolo": "billing/editStudente", 
        "titoli_sezioni": [
            "Piano Rateale Studente",
        ], 
        "sezioni": [
            "In questa sezione è possibile <b>visualizzare e modificare i dati relativi al piano rateale del singolo studente</b>. Sono disponibili gli importi pagati e quelli da pagare dallo studente selezionato. È possibile consultare il costo complessivo a studente e <b>aggiungere una nuova rata</b> - scegliendo la data, l’importo e lo stato della rata (<b>non pagata, da verificare, pagata</b>) - qualora ce ne fosse la necessità.<br/>Puoi visualizzare comodamente l’elenco delle rate che compongono il piano dello studente e, se necessario, eliminarle tramite apposita icona ##0##",
        ], 
        "immagini": [
            [<DeleteOutline color="red" />]
        ]
    },
    {
        "titolo": "billing/studenti", 
        "titoli_sezioni": [
            "Fatture Studenti"
        ], 
        "sezioni": [
            "Puoi <b>consultare la lista degli studenti</b> in modo agevole e cliccare sulla riga dello studente di riferimento per <b>visualizzare i dati delle rate associate allo studente stesso</b>.<br/>Inoltre, puoi scaricare i dati di fatturazione degli anni accademici ed ottenere il relativo documento Excel. Ti basterà selezionare l’anno accademico di interesse e cliccare sull’apposito bottone <b>”Genera Excel”</b><br/><br/>##0##",
        ], 
        "immagini": [
            [
                <img src={ require('../images/anno_acc.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
   },
   {
        "titolo": "billing/studenteDetails", 
        "titoli_sezioni": [
            "Rate Studente"
        ], 
        "sezioni": [
            "In questa sezione è possibile visualizzare in modo veloce le <b>rate del singolo studente</b> selezionato. Per ogni rata viene indicata la data, l’importo, lo stato di pagamento e l’eventuale invio della fattura elettronica.<br/>Per apportare delle <b>modifiche al piano rateale</b> dello studente basta cliccare sull’icona accanto al nome del corso. ##0##"
        ], 
        "immagini": [
            [<Edit />]
        ]
    },
    {
        "titolo": "billing/ritirati", 
        "titoli_sezioni": [
            "Studenti Ritirati",
        ], 
        "sezioni": [
            "Nella Sezione <b>Studenti Ritirati</b> è possibile consultare la lista degli studenti che non partecipano più ai corsi. Per avere <b>maggiori informazioni</b> circa il piano rateale dello studente ritirato, è necessario <b>cliccare sulla linea di riferimento</b>. ",
        ], 
        "immagini": [[]]
   },
   {
        "titolo": "billing/daVerificare", 
        "titoli_sezioni": [
            "Pagamenti da Verificare"
        ], 
        "sezioni": [
            "In questa Sezione puoi visualizzare i <b>pagamenti da verificare</b>. Nella tabella, infatti, vengono indicati tutti i dati delle rate degli studenti: <br/><br/> nome, cognome, corso, data e importo."
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/inRitardo", 
        "titoli_sezioni": [
            "Visualizzare i Pagamenti in Ritardo"
        ], 
        "sezioni": [
            "Nella Sezione <b>pagamenti in ritardo</b> è possibile consultare l’<b>elenco degli studenti che hanno dei ritardi nei pagamenti</b>. Per ogni studente, infatti, dalla tabella è possibile visualizzare il corso di riferimento, la data del pagamento in ritardo e il relativo importo."
        ], 
        "immagini": [[]]
   },
   {
        "titolo": "billing/insegnanti", 
        "titoli_sezioni": [
            "Fatturazione - Insegnanti"
        ], 
        "sezioni": [
            "Nella Sezione <b>insegnanti</b> puoi facilmente consultare l’elenco di tutti i tuoi insegnanti. Cliccando sulla riga di ogni insegnante potrai accedere ai <b>relativi dati e documenti di fatturazione</b>"       
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/fattureInsegnante", 
        "titoli_sezioni": [
            "Fatture Insegnante"
        ], 
        "sezioni": [
            "In questa Sezione è possibile consultare l’elenco delle fatture dell’insegnante selezionato - con relative date, importi, stati dei pagamenti e eventuali note. Inoltre, puoi <b>aggiungere comodamente una nuova fattura</b> cliccando sull’apposito bottone in altro a destra <b>“Nuova”.</b><br/><br/>##0##<br/><br/>Da qui, puoi <b>inserire la data della fattura, l’importo, lo stato (non pagata o pagata), aggiungere eventuali note e caricare i file da allegare.</b>"
        ], 
        "immagini": [
            [
                <img src={ require('../images/nuova.png') } style={{ width: '100%', height: 40, objectFit: 'contain', textAlign: 'center' }} />
            ]
        ]
   },
   {
        "titolo": "billing/fattureInsegnanti", 
        "titoli_sezioni": [
            "Fatture Insegnanti"
        ], 
        "sezioni": [
            "In questa Sezione è possibile consultare in modo semplice e veloce l’<b>elenco delle fatture degli insegnanti</b>. Per ogni fattura vengono visualizzati il nome dell’insegnante di riferimento, la data, l’importo, lo stato e le eventuali note. Inoltre, <b>cliccando sulla fattura di interesse è possibile modificarne i dati o eliminarla</b> - ad esempio, cambiare l’importo oppure aggiungere un file."
        ], 
        "immagini": [[]]
    },
    {
        "titolo": "billing/electronicReceipts", 
        "titoli_sezioni": [
            "Fatturazione Elettronica",
            "PDF Fattura Elettronica"
        ], 
        "sezioni": [
            "Nella Sezione <b>fatturazione elettronica</b> è possibile consultare l’elenco delle fatture elettroniche degli studenti. Per ogni fattura, infatti, vengono indicati vari dati - il numero, la data, l’importo, il nome dello studente con il relativo Codice Fiscale. ",
            "Cliccando sull’apposita icona ##0##, per ogni fattura, sarà possibile visualizzare il documento PDF ufficiale. Il file contiene tutti i dati inviati al SDI dell'Agenzia delle Entrate: <br/><br/>dati del fornitore e del cliente; tipologia e numero del documento; la causale; descrizione, prezzi e IVA della prestazione; riepilogo dati; informazioni sul metodo di pagamento e relativo importo. "
        ], 
        "immagini": [
            [], 
            [
                <img src={ require('../images/pdf_bill.png') } style={{ width: 20, height: 20, objectFit: 'contain', textAlign: 'center' }} />,
            ]
        ]
   }

]